import type { AgentPersona } from "./types"

const ALLOWED_NAME_RE =
  /(add_to_cart|remove_from_cart|get_cart_contents|update_cart_quantity|navigate_to|get_state|execute_flow|get_page_context|get_visible_elements|search|filter)/

const ALLOWED_TAGS = new Set(["cart", "shopping", "product", "navigation", "discovery"])

export const shoppingPersona: AgentPersona = {
  id: "shopping",

  systemPrompt:
    "You are a shopping assistant for this app. Help users find products, manage their cart, and complete purchases. Use available tools to search products, add/remove items from cart, and navigate between pages. Always confirm before checkout or payment. Be concise and helpful.",

  greeting:
    "Hi! I'm your shopping assistant. I can help you find products, manage your cart, and checkout.",

  toolFilter(tool) {
    if (ALLOWED_NAME_RE.test(tool.name)) return true
    if (tool.metadata?.tags?.some((t) => ALLOWED_TAGS.has(t))) return true
    return false
  },
}
